/**
 * @flow
 * @relayHash 8ff30b67e63e19e6d8b654577238a9d1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetUserBkgImageInput = {
  userId: string,
  imageId: string,
  clientMutationId?: ?string,
};
export type SetBackgroundImageMutationVariables = {|
  input: SetUserBkgImageInput
|};
export type SetBackgroundImageMutationResponse = {|
  +setUserBkgImage: ?{|
    +user: ?{|
      +backgroundOption: ?string,
      +backgroundImage: ?{|
        +id: string,
        +imageURL: ?string,
      |},
    |}
  |}
|};
export type SetBackgroundImageMutation = {|
  variables: SetBackgroundImageMutationVariables,
  response: SetBackgroundImageMutationResponse,
|};
*/


/*
mutation SetBackgroundImageMutation(
  $input: SetUserBkgImageInput!
) {
  setUserBkgImage(input: $input) {
    user {
      backgroundOption
      backgroundImage {
        id
        imageURL
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetUserBkgImageInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "SetUserBkgImageInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "backgroundOption",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "backgroundImage",
  "storageKey": null,
  "args": null,
  "concreteType": "BackgroundImage",
  "plural": false,
  "selections": [
    v3,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageURL",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "SetBackgroundImageMutation",
  "id": null,
  "text": "mutation SetBackgroundImageMutation(\n  $input: SetUserBkgImageInput!\n) {\n  setUserBkgImage(input: $input) {\n    user {\n      backgroundOption\n      backgroundImage {\n        id\n        imageURL\n      }\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SetBackgroundImageMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgImage",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserBkgImagePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v2,
              v4
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SetBackgroundImageMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgImage",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserBkgImagePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v2,
              v4,
              v3
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd7e7b1b43266cd83ef7ba1760d26aded';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/mutations/__generated__/SetBackgroundImageMutation.graphql.js